import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Calculator, LineChart } from "lucide-react";

/**
 * Barre CTA mobile fixée en bas — Estimer / Simuler.
 * Se cache automatiquement à l'approche du footer et sur certaines pages.
 */
const HIDDEN_PATHS = ["/simulateur", "/estimer", "/login", "/admin"];

export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(false);
  const rafRef = useRef(null);

  const isHiddenPage = HIDDEN_PATHS.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (isHiddenPage) return;
    const check = () => {
      const footer = document.querySelector("footer[data-testid='site-footer']");
      if (!footer) { setHidden(false); return; }
      const rect = footer.getBoundingClientRect();
      const isFooterVisible = rect.top < window.innerHeight - 20;
      setHidden(isFooterVisible);
    };
    const onScroll = () => {
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => { check(); rafRef.current = null; });
    };
    check();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", check);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [pathname, isHiddenPage]);

  if (isHiddenPage) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={hidden}
      className={`lg:hidden fixed inset-x-0 bottom-0 z-30 border-t border-navy/10 bg-cream/95 backdrop-blur px-3 py-2 grid grid-cols-2 gap-2 transition-transform duration-300 ${hidden ? "translate-y-full" : "translate-y-0"}`}
      style={{ paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom))" }}
    >
      <Link
        to="/estimer"
        data-testid="mobile-cta-estimer"
        className="flex items-center justify-center gap-2 border border-navy text-navy py-3 text-sm font-bold tracking-wide hover:bg-navy hover:text-cream transition-colors"
      >
        <LineChart size={16} /> Estimer mon bien
      </Link>
      <Link
        to="/simulateur"
        data-testid="mobile-cta-simuler"
        className="flex items-center justify-center gap-2 bg-accent-brand text-white py-3 text-sm font-bold tracking-wide hover:bg-[#B08D22] transition-colors"
      >
        <Calculator size={16} /> Simuler
      </Link>
    </div>
  );
}
